import type { HTMLAttributes } from "react";

export function Card({ className = "", ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={[
        "rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)]",
        className,
      ].join(" ")}
      {...rest}
    />
  );
}

export function CardHeader({ className = "", ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={[
        "px-5 py-4 border-b border-[var(--color-border)]",
        className,
      ].join(" ")}
      {...rest}
    />
  );
}

export function CardTitle({ className = "", ...rest }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h2
      className={[
        "text-base font-semibold text-[var(--color-text)]",
        className,
      ].join(" ")}
      {...rest}
    />
  );
}

export function CardBody({ className = "", ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={["p-5", className].join(" ")} {...rest} />;
}
